export enum OrganizationActionTypes {
	SET = "@@organization/SET",
	CLEAR = "@@organization/CLEAR",
	UPDATE = "@@organization/UPDATE",
}

export enum OrganizationTypeApi {
	PROD = "PROD",
	TEST = "TEST",
	DEMO = "DEMO",
}

export type OrganizationState = {
	id?: number;
	name?: string;
	status?: string;
	permissions: string[];
	applications: string[];
	accept_privacy?: boolean;
	accept_terms?: boolean;
	accept_rules?: boolean;
	alias?: string;
	company_id?: string;
	company_name?: string;
	category?: string;
	tax_id_no?: string;
	description?: string;
	is_admin?: boolean;
	timezone?: string;
	languages: string[];
	currency?: string;
	support?: boolean;
	license_expires_at?: string;
	more?: any;
	partner?: boolean;
	license_type?: string;
	properties?: Record<string, number | string>;
	accesses?: Record<string, string>;
	type?: OrganizationTypeApi | null;
};
